module.exports = __webpack_public_path__ + "static/img/card-star-bg.c0d98fed.png";